module.exports = __webpack_public_path__ + "assets/img/home2-box2-5.c1671ce2.png";